import classnames from "classnames";
import React from "react";

import { ProductFeatureModel } from "@api/mappers/products.mapper";

import { displayFeature } from "@utils/features/display";

import "./description.scss";

export type ProductTileDescriptionProps = {
    items?: ProductFeatureModel[];
    showItems: boolean;
    amountOfFeatures: number;
    className?: string;
};

export const renderFeature = (feature: ProductFeatureModel) => {
    const featureValue = displayFeature(feature);

    if (featureValue.toLowerCase() === "true") {
        return (
            <span>
                <i className="las la-check"></i>
            </span>
        );
    }

    if (featureValue.toLowerCase() === "false") {
        return (
            <span>
                <i className="las la-times"></i>
            </span>
        );
    }

    return featureValue;
};

const ProductTileDescription = ({
    items,
    showItems,
    amountOfFeatures,
    className,
}: ProductTileDescriptionProps) => {
    return (
        <div className={classnames("product-layout-description", className)}>
            {items && showItems && (
                <ul className="product-layout-description__list">
                    {items.slice(0, amountOfFeatures).map((feature, key) => (
                        <li key={key} className={"w-100"}>
                            <span className={"pr-2 text-primary"}>
                                &#x25A0;
                            </span>
                            {feature.name}: {renderFeature(feature)}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export { ProductTileDescription };
